module.exports = __webpack_public_path__ + "media/icons/shock-absorber-66992c15.svg";